import {Component, Input} from '@angular/core';
import {FeatherModule} from 'angular-feather';
import {RouterLink} from '@angular/router';
import {NgForOf, NgIf} from "@angular/common";

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  standalone: true,
  imports: [RouterLink, FeatherModule, NgForOf, NgIf],
})
export class BreadcrumbComponent {
  @Input()
  items!: { label: string, link?: string }[]; // Ahora acepta enlaces opcionales

  constructor() {
    //constructor
  }

  ngOnInit(): void {
  }

}
